import { useContext } from 'react';
import { BookingContext } from '../contexts/BookingContextProvider';

export const useBookingContext = () => useContext(BookingContext);
